import DateInput from './DateInput.vue';

export default DateInput;
